export default "__VITE_ASSET__DjDuGYf1__"